import '@chewy/kib-carousels-styles/dist/styles/kib-carousel.css';

import { KibCarousel, KibCarouselItem } from '@chewy/kib-carousels-react';
import { KibProductRating } from '@chewy/kib-product-react';
import cx from 'classnames';

import { FadeUpOnScroll } from '../FadeUpOnScroll/FadeUpOnScroll';

import styles from './styles.module.scss';

import beanie from '@/assets/testimonials/beanie-love.png';
import otis from '@/assets/testimonials/otis-scraps.png';
import parentsLikeYouBadge from '@/assets/testimonials/pet-parents-like-you-badge.svg';
import sandie from '@/assets/testimonials/sandie-goldendoodle.png';

export const Testimonials = ({}: {}) => {
  const testimonials = [
    // { id: 0.1 }, // spacer for min-lg screens
    {
      id: 1,
      title: 'Fresh flips!!',
      body: 'Sandie our Goldendoodle puppy almost does a literal backflip over the food. And the freshness and ingredients are top tier!',
      author: 'Michael',
      date: '1/23/2026',
      image: sandie.src,
    },
    {
      id: 2,
      title: 'Great dog food for healthy diet.',
      body: 'Keeps my dog’s sensitive stomach well.',
      author: 'Judy',
      date: '2/14/2026',
    },
    {
      id: 3,
      title: 'Quality for price',
      body: 'The value for this food is great! Dogs love it and bought as a topper portion it’s quite affordable.',
      author: 'Bianca',
      date: '2/5/2026',
    },
    {
      id: 4,
      title: 'My dog loves this food',
      body: 'Both my dogs who are very picky eaters love this food. Also the food was extremely well packaged to prevent defrosting.',
      author: 'Marylee',
      date: '3/4/2026',
    },
    {
      id: 5,
      title: 'Texture is perfect',
      body: 'Since my fur baby has no teeth it’s perfect for her',
      author: 'Janet',
      date: '3/10/2026',
    },
    {
      id: 6,
      title: 'Thanksgiving every day',
      body: 'Otis scarfs down his meals. There is never a crumb left. He digests it perfectly and has energy to spare.',
      author: 'Amy',
      date: '1/7/2026',
      image: otis.src,
    },
    // { id: 0.2 }, // spacer for min-lg screens,
    {
      id: 7,
      title: 'Finicky Yorkies loved it',
      body: 'My Yorkies snub their nose at everything. I have tried so many. They love this stuff.',
      author: 'Dawn',
      date: '2/23/2026',
    },
    {
      id: 8,
      title: 'They both loved it.',
      body: 'Beanie can be a little finicky but she liked this!',
      author: 'Jo',
      date: '12/4/2025',
      image: beanie.src,
    },
    {
      id: 9,
      title: 'Extremely picky puppy loves',
      body: 'I have 1 yo small labradoodle that would not eat anything for more than a day. I use this as a topper now and she loves this daily. Win Win',
      author: 'Donna',
      date: '3/9/2026',
    },
  ];
  return (
    <div className={styles.root}>
      <KibCarousel className={styles.testimonialCarousel}>
        {testimonials.map((testimonial) => (
          <FadeUpOnScroll
            key={testimonial.id}
            as={KibCarouselItem}
            className={cx(styles.testimonialCard, { [styles.spacer]: !testimonial.title })}
          >
            {testimonial.image && (
              <div className={styles.imageContainer}>
                <img
                  src={testimonial.image}
                  alt={`${testimonial.author}'s dog`}
                  className={styles.image}
                />
              </div>
            )}

            {testimonial.title && (
              <div className={styles.textContainer}>
                <KibProductRating size="large" rating={5} className={styles.starRating} />
                <h3 className={styles.title}>{testimonial.title}</h3>
                <p className={styles.body}>&quot;{testimonial.body}&quot;</p>
                <p className={styles.author}>
                  - {testimonial.author} on {testimonial.date}
                </p>
              </div>
            )}
          </FadeUpOnScroll>
        ))}
      </KibCarousel>

      <div className={styles.petParentsBadge}>
        <FadeUpOnScroll>
          <img src={parentsLikeYouBadge.src} alt="Pet Parents Like You Badge" />
        </FadeUpOnScroll>
      </div>
    </div>
  );
};
